/* DERMA TRAINING - reveal more FAQ entries only when more than six exist.
   Answers stay present in the HTML; semantic details/summary remains functional. */
(() => {
  const listSelector = '.dc-faq-list, .dtsc__faq-list, .dtcity__faq-list, .dtloc__faq';
  let count = 0;
  function mount(scope) {
    scope.querySelectorAll(listSelector).forEach(list => {
      if (list.dataset.dtFaqCompact === '1') return;
      const entries = Array.from(list.children).filter(node => node.tagName === 'DETAILS');
      if (entries.length <= 6 || !list.closest('.dc-faq,.dtsc__faq,.dtcity__faq,.dtloc__faq')) return;
      list.dataset.dtFaqCompact = '1';
      // Prioritize the six questions prospective learners need most.
      const priorities = [
        /durée|dure combien|combien de temps|heures/i,
        /débutant|accessible|sans expérience/i,
        /pratique|modèle|exercices/i,
        /prérequis|hygiène|salubrité/i,
        /financ|OPCO|France Travail/i,
        /\bCPF\b/i
      ];
      const selected = [];
      priorities.forEach(pattern => {
        const found = entries.find(item =>
          !selected.includes(item) && pattern.test(item.querySelector('summary')?.textContent || '')
        );
        if (found) selected.push(found);
      });
      const ordered = [...selected, ...entries.filter(item => !selected.includes(item))];
      // DOM reordering preserves the full original answer and its native toggle.
      ordered.forEach(item => list.appendChild(item));
      if (!list.id) list.id = 'dt-training-faq-' + (++count);
      ordered.slice(6).forEach(item => { item.open = false; item.hidden = true; });
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dt-faq-more';
      button.setAttribute('aria-controls', list.id);
      button.setAttribute('aria-expanded', 'false');
      const extra = entries.length - 6;
      const collapsedLabel = extra === 1 ? 'Voir la dernière question' : 'Voir les ' + extra + ' autres questions';
      button.textContent = collapsedLabel;
      button.addEventListener('click', () => {
        const expand = button.getAttribute('aria-expanded') !== 'true';
        ordered.slice(6).forEach(item => {
          if (!expand) item.open = false;
          item.hidden = !expand;
        });
        button.setAttribute('aria-expanded', String(expand));
        button.textContent = expand ? 'Réduire les questions' : collapsedLabel;
      });
      list.insertAdjacentElement('afterend', button);
    });
  }
  const init = () => { if (document.body?.dataset.dtPage?.startsWith('formation-')) mount(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
